.container {
  max-width: 886px;
  margin: calc(4 * var(--spacer)) 0 calc(6 * var(--spacer)) calc(5 * var(--spacer));
  min-height: 766px;
}

.update-info-box {
  padding: 0 calc(7 * var(--spacer)) 0 0;
  margin-bottom: calc(4 * var(--spacer));
}

.field-container {
  height: calc(4 * var(--spacer));
  margin-bottom: var(--spacer);
  display: flex;
  align-items: center;
}

.schedule-field {
  gz-radio {
    margin-bottom: 0;
  }
}

.disabled {
  gz-light-grid {
    opacity: 0.6;
  }

  gz-text,
  gz-title,
  ::part(radio-label),
  ::part(checkbox-label) {
    color: var(--grey-layout-200-disabled);
  }

  gz-form-field {
    &::part(form-field-label) {
      color: var(--grey-layout-200-disabled);
    }
  }

  gz-link {
    pointer-events: none;
    opacity: 0.3;
  }
}

gz-input-error {
  margin-top: -7px;
  padding-left: 142px;
}
